import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { BREAKPOINTS, GLOBAL, FONT_SIZE, FONT_WEIGHT, LINE_HEIGHT } from '@/constants';

const ExtraSmallStyles = css`
  font-family: ${GLOBAL.BASE_FONT_FAMILY};
  font-size: ${FONT_SIZE.XX_SMALL};
  line-height: ${LINE_HEIGHT.BODY.XX_SMALL};
  font-weight: ${FONT_WEIGHT.REGULAR};
  letter-spacing: normal;
  margin: 0;

  @media (min-width: ${BREAKPOINTS.SM}px) {
    font-size: ${FONT_SIZE.X_SMALL};
    line-height: ${LINE_HEIGHT.BODY.X_SMALL};
  }

  @media (min-width: ${BREAKPOINTS.LG}px) {
    font-size: ${FONT_SIZE.SMALL};
    line-height: ${LINE_HEIGHT.BODY.SMALL};
  }
`;

const ExtraSmall = styled.p`
  ${ExtraSmallStyles}
`;

export { ExtraSmall, ExtraSmallStyles };
